import AltInstance from '../../../../Common/Globals/Scripts/AltInstance';
import ActionHelper from '../../../../Common/Actions/ActionHelper';
import CsvImportApi from '../Apis/CsvImportApi';
import { fileHasCsvExtension, fileAppearsToContainCsvContent } from '../Business/CsvImport';

class CsvImportActions {
    constructor() {
        this.generateActions(
            'importStarted',
            'importSucceeded',
            'importFailed',
            'fileSelected',
            'cancelImport');
    }

    async submitCsvImportFile(file, apiFunctionName) {
        this.importStarted();

        const isValid = fileHasCsvExtension(file) && await fileAppearsToContainCsvContent(file);
        if(!isValid) {
            this.importFailed(['The selected file is not a valid CSV file. Please select a CSV file with a .CSV file extension and try again.']);
            return;
        }

        const validationErrors = await ActionHelper.executeRequest(() => CsvImportApi.submitCsvImport(file, apiFunctionName));
        if(validationErrors.length === 0) {
            this.importSucceeded();
        }
        else {
            this.importFailed(validationErrors);
        }
    }
}

export default AltInstance.createActions(CsvImportActions);
